import { RootState } from '../..';

export const documentsByIdsSelector = (state: RootState) => state.documents.documents;

export const documentsCount = (state: RootState) => state.documents.documentsCount;
